<app-page>
  <app-notifications-list></app-notifications-list>
</app-page>
